export default {
      id: "ic-nav-pause-usage",
      viewBox: "0 0 17 17",
      url: "../dist/images/" + "sprite.svg#ic-nav-pause-usage",
      toString: function () {
        return this.url;
      }
    }